class HeroBanner extends HTMLElement {
  connectedCallback() {
    this.fullHeight = this.hasAttribute('data-full-height');
    this.adjustMinHeight();
    window.addEventListener('resize', debounce(() => this.adjustMinHeight(), 300).bind(this));
    this.currentScheme = this.querySelector('hero-banner-slide')?.dataset?.colorScheme;
    this.carousel = this.querySelector('carousel-block');
    this.jumpDown = this.querySelector('.jump-down');
    this.changeCounterColors();
    this.carousel.addEventListener('slide', this.changeCounterColors.bind(this));
    if(this.jumpDown) {
      this.jumpDown.querySelector('a')?.addEventListener('click', this.handleJumpDown.bind(this));
    }
  }

  adjustMinHeight() {
    if(this.fullHeight && this.closest('section') === this.closest('section').parentNode.children[0]) {
      const top = this.getBoundingClientRect().top + window.scrollY;
      this.style.minHeight = `calc(var(--min-height) - ${top}px)`;
    }
    else {
      this.style.minHeight = 'var(--min-height)';
    }
  }

  changeCounterColors(event) {
    const index = event ? event.detail.currentSlide : 0;
    this.carousel.controls.classList.remove(`color-${this.currentScheme}`);
    if(this.jumpDown) {
      this.jumpDown.classList.remove(`color-${this.currentScheme}`);
    }
    this.currentScheme = this.carousel.items[index].dataset.colorScheme;
    this.carousel.controls.classList.add(`color-${this.currentScheme}`);
    if(this.jumpDown) {
      this.jumpDown.classList.add(`color-${this.currentScheme}`);
    }
  }

  handleJumpDown(e) {
    e.preventDefault();
    const element = this.closest('section').nextSibling;
    gsap.to(window, {
      duration: 0.5, 
      scrollTo: element
    })
  }
}

customElements.define('hero-banner', HeroBanner)